import { useNavigate } from "react-router-dom";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../components/BasicComponents/DisplayDados/SessaoConfiguracao"
import { IDataFormularios } from "../../../types/api/configuracoes/pesquisar-formularios"
import { useCallback } from "react";

export default function FormulariosDyn() {

    const navigate = useNavigate();

    const handleRedirectDetail = useCallback((id: number) => {
        navigate(`/configuracoes/formularios/${id}`)
    }, [navigate])

    return (
        <SessaoConfiguracao<IDataFormularios>
            titulo="Formulários"
            endpoints={{
                listar: "/configuracoes/pesquisar-formularios",
                deletar: "nenhuma-rota-cadastrada",
            }}
            colunas={colunas}
            queryKey="pesquisar-formularios"
            onEditar={(fluxo) => {
                handleRedirectDetail(fluxo.id)
            }}
            possuiAdicionar={false}
            podeDeletar={() => false}
            mensagemSucessoDeletar="Formulário deletado com sucesso!"
            mensagemErroDeletar="Erro ao deletar formulário!"
            mensagemSemDados="Nenhum formulário encontrado."
        />

    )
}

const colunas: ConfiguracaoColunas<IDataFormularios>[] = [
    {
        campo: "nome",
        titulo: "Nome",
    },
    {
        campo: "versao",
        titulo: "Versão",
    },
    {
        campo: "status",
        titulo: "Status",
    }
];